(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var T13 = {
        brakD: __pewniaki_inline_cfg[0],
        brakZ: __pewniaki_inline_cfg[1],
        mini:  __pewniaki_inline_cfg[2],
        maxi:  __pewniaki_inline_cfg[3],
        model: __pewniaki_inline_cfg[4],
        brakM: __pewniaki_inline_cfg[5]
    };

(function () {
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var f1 = function (v) { return v == null ? '—' : Number(v).toFixed(1).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    // liczniki malejaco, przy rownych — mniejsza liczba pierwsza
    var posortuj = function (h) { return Object.keys(h).map(Number).sort(function (a, b) { return h[b] - h[a] || a - b; }); };
    // to samo zdanie, ktore sklada Twig dla okna domyslnego — SSR i JS maja dawac ten sam tekst
    var zdanie = function (wzor, h, N, pm) {
        var top = posortuj(h)[0];
        if (top == null || !N) { return null; }
        var s = wzor.replace('%1', top).replace('%2', tys(h[top])).replace('%3', tys(N)).replace('%4', f1(h[top] * 100 / N));
        return s + (pm[top] != null ? T13.model.replace('%1', f1(pm[top] * 100)) : T13.brakM);
    };
    window.PEWNIAKI_ANALIZA = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[6] + '/analizy/struktura.json',
        wersja: __pewniaki_inline_cfg[7],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[8] + '/lata/',
        pula:   JSON.parse(String(__pewniaki_inline_cfg[9])),
        typuje: JSON.parse(String(__pewniaki_inline_cfg[10])),
        // Zakres lat: suma SUROWYCH licznikow min/max z rocznikow, nigdy list TOP (plan V2 §5.3).
        sumujLata: function (roczniki) {
            var mn = {}, mx = {}, N = 0;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.min || {}).forEach(function (a) { mn[a] = (mn[a] || 0) + r.min[a]; });
                Object.keys(r.max || {}).forEach(function (b) { mx[b] = (mx[b] || 0) + r.max[b]; });
            });
            return { losowan: N, min: mn, max: mx, powod: null };
        },
        wnioski: function (o, klucz, dane) {
            if (!o) { return [T13.brakD]; }
            var model = dane.model || {}, p = [];
            var z1 = zdanie(T13.mini, o.min || {}, o.losowan || 0, model.min || {});
            var z2 = zdanie(T13.maxi, o.max || {}, o.losowan || 0, model.max || {});
            if (z1) { p.push(z1); }
            if (z2) { p.push(z2); }
            return p.length ? p : [T13.brakZ];
        },
        render: function (okno, klucz, dane) {
            var q = function (s) { return document.querySelector(s); };
            var ustaw = function (s, v) { var e = q(s); if (e) { e.textContent = v; } };
            var sekcja = q('[data-skrajne]'), model = dane.model || {};
            if (!okno) {
                ['n', 'min-top', 'min-top-pct', 'min-top-model', 'max-top', 'max-top-pct', 'max-top-model', 'min-roznych', 'max-roznych']
                    .forEach(function (a) { ustaw('[data-skrajne-' + a + ']', '—'); });
                ['min', 'max'].forEach(function (a) { var t = q('[data-skrajne-tabela-' + a + '] tbody'); if (t) { t.innerHTML = ''; } });
                if (sekcja) { sekcja.hidden = true; }
                return;
            }
            if (sekcja) { sekcja.hidden = false; }
            var N = okno.losowan || 0;
            ustaw('[data-skrajne-n]', tys(N));
            var karta = function (rola, h, pm) {
                var klucze = posortuj(h), top = klucze[0];
                ustaw('[data-skrajne-' + rola + '-top]', top != null ? top : '—');
                ustaw('[data-skrajne-' + rola + '-top-pct]', top != null && N ? f1(h[top] * 100 / N) + '%' : '—');
                ustaw('[data-skrajne-' + rola + '-top-model]', top != null && pm[top] != null ? f1(pm[top] * 100) + '%' : '—');
                ustaw('[data-skrajne-' + rola + '-roznych]', tys(klucze.length));
                var t = q('[data-skrajne-tabela-' + rola + '] tbody');
                if (t) {
                    t.innerHTML = klucze.slice(0, 10).map(function (a) {
                        return '<tr><td class="liczbowa">' + a + '</td><td class="liczbowa">' + tys(h[a]) + '</td><td class="liczbowa">'
                             + (N ? f1(h[a] * 100 / N) + '%' : '—') + '</td><td class="liczbowa">' + (pm[a] != null ? f1(pm[a] * 100) + '%' : '—') + '</td></tr>';
                    }).join('');
                }
            };
            karta('min', okno.min || {}, model.min || {});
            karta('max', okno.max || {}, model.max || {});
        }
    };
})();
})();
